module.exports = __webpack_public_path__ + "static/media/winter.61583831.JPG";